import React, { Component } from 'react'
import './Header.css';
export default class Header extends Component {
    render() {
        return (
            <div className="spacex-header">
                SPACEX LAUNCH PROGRAMS
            </div>
        )
    }
}


